<template>
  <div>
    <b-card>
      <b-row>
        <b-col>
          <teams-title-card />
        </b-col>
        <b-col>
          <departments-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <teams-status-card />
        </b-col>
      </b-row>
    </b-card>
    <team-members v-if="itemData.id" />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import TeamsTitleCard from '@/views/Teams/Elements/TitleCard.vue'
import DepartmentsCard from '@/views/Teams/Elements/DepartmentsCard.vue'
import TeamsStatusCard from '@/views/Teams/Elements/StatusCard.vue'
import TeamMembers from '@/views/Teams/Components/Members.vue'

export default {
  name: 'TeamsItemForm',
  components: {
    DepartmentsCard,
    TeamsStatusCard,
    TeamsTitleCard,
    BCard,
    BRow,
    BCol,
    TeamMembers,

  },
  computed: {
    itemData() {
      return this.$store.getters['teams/dataItem']
    },
  },
}
</script>
